import { render, staticRenderFns } from "./ApprovalInfoContainer.vue?vue&type=template&id=e1a070cc&scoped=true"
import script from "./ApprovalInfoContainer.vue?vue&type=script&lang=js"
export * from "./ApprovalInfoContainer.vue?vue&type=script&lang=js"
import style0 from "./ApprovalInfoContainer.vue?vue&type=style&index=0&id=e1a070cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a070cc",
  null
  
)

export default component.exports